function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#FFF1D6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}, React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#FF3B30"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#a)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 52.54V49.4c0-3.45-2.823-6.276-6.276-6.276H12.276C8.823 43.125 6 45.948 6 49.401v3.138a29.138 29.138 0 0018.498 6.592A29.163 29.163 0 0043 52.539z",
  fill: "#E7E3E7"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 52.54V49.4c0-3.45-2.823-6.276-6.276-6.276H27.36l-.493.312 1.747 5.394-1.135 10.145A29.118 29.118 0 0043 52.54zm-37 0V49.4c0-3.45 2.823-6.276 6.276-6.276h9.364l.493.312-1.747 5.394 1.135 10.145A29.128 29.128 0 016 52.54z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.091 47.208l.526 1.623-1.135 10.145a29.054 29.054 0 003.512-.573l2.292-4.428-2.797-8.84c-.867.246-1.673 1.007-2.398 2.073z",
  fill: "#30295E"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 28.371c2.784 0 5.063 2.28 5.063 5.064v9.693c0 2.785-2.279 5.064-5.063 5.064-2.785 0-5.064-2.28-5.064-5.064v-9.693a5.077 5.077 0 015.064-5.064z",
  fill: "#E9BAA8"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 28.371c2.784 0 5.063 2.28 5.063 5.064v8.311a10.217 10.217 0 01-4.362.978c-2.122 0-4.101-.654-5.762-1.771v-7.518a5.072 5.072 0 015.06-5.064zm-13.388-1.498a3.22 3.22 0 003.138 3.305c.05 0 .101.003.149 0-.327-1.153-.505-2.31-.505-3.412v-.983c.003-2.021-2.702-1.887-2.782 1.09zm26.772 0a3.223 3.223 0 01-3.138 3.305c-.05 0-.101.003-.149 0 .327-1.153.505-2.31.505-3.412v-.983c-.002-2.021 2.705-1.887 2.782 1.09z",
  fill: "#D58881"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 8.17c-5.83 0-10.603 4.93-10.603 10.956v9.967c0 6.027 4.772 10.957 10.603 10.957 5.83 0 10.602-4.93 10.602-10.957v-9.967C35.101 13.1 30.332 8.17 24.502 8.17z",
  fill: "#E9BAA8"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.528 24.47s-1.424.032-1.424 1.31c0 0-1.004-1.317-.796-2.966 0 0-2.72-3.17-2.594-6.713.122-3.542 2.882-4.3 2.882-4.3 6.618 1.935 1.932 6.624 1.932 12.668zm-24.053 0s1.424.032 1.424 1.31c0 0 1.004-1.317.796-2.966 0 0 2.719-3.17 2.594-6.713-.125-3.542-2.882-4.3-2.882-4.3-6.621 1.935-1.932 6.624-1.932 12.668z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.183 5.498a6.266 6.266 0 019.176 5.551 6.266 6.266 0 01-10.56 4.565 3.794 3.794 0 01-3.373 2.05 3.784 3.784 0 01-2.779-1.21 3.801 3.801 0 01-6.443-.5A5.44 5.44 0 0115.439 5.22a5.33 5.33 0 011.682.267 6.205 6.205 0 015.533-3.402 6.181 6.181 0 015.53 3.414z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 48.189l3.578 3.432s1.322.773 1.848-.35c.523-1.124 2.122-8.146 2.122-8.146l-2.485-.92c-.003.002-.14 4.347-5.063 5.984z",
  fill: "#fff"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.563 44.81a.141.141 0 01.208.19c-.003.003-1.272 1.335-1.272 4.526v6.562c-.095.047-.19.092-.282.14v-6.702c0-3.301 1.343-4.71 1.346-4.716z",
  fill: "#1C1341"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.909 47.208l-.526 1.623 1.135 10.145a29.06 29.06 0 01-3.513-.573l-2.294-4.428 2.797-8.84c.87.246 1.676 1.007 2.4 2.073z",
  fill: "#30295E"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 48.189l-3.578 3.432s-1.326.773-1.849-.35c-.526-1.124-2.122-8.146-2.122-8.146l2.485-.92c0 .002.137 4.347 5.064 5.984z",
  fill: "#fff"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.437 44.81a.141.141 0 00-.208.19c.003.003 1.274 1.335 1.274 4.526v6.562l.283.14v-6.702c0-3.301-1.346-4.71-1.35-4.716z",
  fill: "#1C1341"
}), React.createElement("path", {
  opacity: 0.6,
  d: "M25.04 27.84s.059.142.154.323l.154.297.078.16c.02.054.05.108.062.158.024.05.027.101.042.149.003.047.011.092.008.137-.005.041-.002.089-.023.127-.012.042-.024.09-.05.128-.024.036-.04.083-.063.113-.027.03-.048.062-.066.086a5.221 5.221 0 00-.056.086s.036-.003.101-.015a.55.55 0 00.262-.101c.023-.017.056-.03.08-.053a.979.979 0 00.071-.08.579.579 0 00.116-.211c.02-.042.02-.083.027-.128.003-.042.015-.09.006-.13a1.036 1.036 0 00-.152-.467 1.374 1.374 0 00-.419-.428c-.178-.12-.333-.152-.333-.152z",
  fill: "#DB9C94"
}), React.createElement("path", {
  d: "M28.87 26.838c.493.02.918-.568.95-1.317.033-.749-.338-1.376-.831-1.396-.494-.021-.919.567-.951 1.316-.03.749.341 1.373.832 1.397z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  d: "M27.446 24.35h-.012c-.338.033-.647-.056-.88-.318a1.521 1.521 0 01-.359-.867c-.03-.342.167-.687.526-.716a.586.586 0 01.455.154.58.58 0 01.148.208c.033.086.021.184.107.238a.397.397 0 00.197.044c.368.021.76.033 1.114-.095.377-.133.734-.327 1.111-.457.387-.134.8-.22 1.207-.155.35.057.674.223.95.449.137.113.708.859.708.859a4.762 4.762 0 00-1.135-.366c-.324-.056-.684.063-1.008.13-.326.072-.642.182-.962.286-.511.17-1.037.312-1.555.464a3.66 3.66 0 01-.612.142z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  opacity: 0.6,
  d: "M25.536 23.426s.017.05.035.137c.006.045.027.092.042.143.015.05.038.107.06.166.04.122.106.253.172.383.038.066.071.131.116.194.038.065.086.121.13.178a1.516 1.516 0 00.297.282c.054.036.11.071.167.095.056.036.116.045.175.069.06.02.116.026.17.041.053.015.104.015.145.02l.14.022s-.033.035-.104.095c-.036.027-.077.068-.137.092-.06.024-.125.065-.205.08-.08.015-.172.039-.267.027a.957.957 0 01-.306-.056c-.054-.012-.101-.042-.152-.066a.547.547 0 01-.143-.09 1.304 1.304 0 01-.246-.23c-.066-.09-.134-.182-.176-.28a1.245 1.245 0 01-.104-.294 1.348 1.348 0 01-.017-.541.878.878 0 01.059-.211.51.51 0 01.071-.146c.045-.068.078-.11.078-.11z",
  fill: "#DB9C94"
}), React.createElement("path", {
  d: "M20.692 26.838c-.494.02-.918-.568-.951-1.317-.033-.749.339-1.376.832-1.396.493-.021.918.567.95 1.316.034.749-.338 1.373-.831 1.397z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  d: "M22.115 24.35h.012c.339.033.648-.056.88-.318.21-.234.33-.552.36-.867.029-.342-.167-.687-.527-.716a.586.586 0 00-.454.154.581.581 0 00-.149.208c-.033.086-.02.184-.107.238a.397.397 0 01-.196.044c-.369.021-.76.033-1.114-.095-.378-.133-.734-.327-1.112-.457-.386-.134-.8-.22-1.206-.155a2.03 2.03 0 00-.951.449c-.137.113-.707.859-.707.859.368-.179.82-.31 1.135-.366.324-.056.683.063 1.007.13.327.072.642.182.963.286.511.17 1.037.312 1.554.464.202.06.404.119.612.142z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  opacity: 0.6,
  d: "M24.026 23.426s.033.042.083.113c.027.036.05.083.071.146.027.062.045.134.06.21.03.155.027.343-.018.542a1.23 1.23 0 01-.104.294c-.041.098-.11.19-.175.28a1.304 1.304 0 01-.247.23c-.041.037-.092.063-.143.09-.05.024-.095.054-.151.065a.954.954 0 01-.306.057c-.098.012-.19-.015-.268-.027-.08-.015-.145-.056-.205-.08-.059-.02-.1-.066-.136-.092a.793.793 0 01-.104-.095s.053-.01.14-.021c.041-.006.088-.006.145-.02.053-.016.113-.022.17-.042.056-.024.118-.033.175-.069.06-.024.113-.06.166-.095.054-.039.107-.077.155-.128.05-.047.098-.098.142-.154.045-.06.092-.113.131-.178.042-.063.077-.128.116-.194.068-.13.13-.261.172-.383.024-.062.048-.119.06-.166.015-.051.035-.099.041-.143.015-.09.03-.14.03-.14z",
  fill: "#DB9C94"
}), React.createElement("path", {
  d: "M23.583 35.182s.164-.003.38.006c.11.003.235.006.363.015.13.003.265.012.401.012.134.003.27.003.396 0 .065 0 .124-.003.184-.006s.119-.003.17-.01c.053-.005.103-.005.148-.008a.904.904 0 01.119-.009c.068-.003.11-.003.11-.003s-.024.033-.075.083a.97.97 0 01-.226.179.856.856 0 01-.172.089 1.603 1.603 0 01-.669.128 1.702 1.702 0 01-.826-.226 1.075 1.075 0 01-.303-.25z",
  fill: "#DB9C94"
}), React.createElement("path", {
  d: "M20.561 33.878c.184-.315.559-.648.728-.794a5.134 5.134 0 012.05-1.072c2.176-.565 4.116.032 5.37 1.73.482.65-.205.816-.33.86-.537.203-1.548-.424-2.1-.543a8.54 8.54 0 00-4.188.14c-.374.11-.81.407-1.209.336-.493-.087-.49-.363-.32-.657z",
  fill: "#7A2742"
}), React.createElement("path", {
  d: "M21.054 34.543s.378-.665.919-.867c.57-.212 1.352-.506 2.695-.455 1.343.05 2.119.223 2.787.538.669.315.924.84.924.84s-.127.06-.374.033c-.172-.017-.363-.074-.642-.172-.32-.116-.743-.33-1.084-.404a8.277 8.277 0 00-2.933-.122c-.966.119-2.137.657-2.292.61zm6.616-1.845c-2.446.273-4.752-.012-5.62-.149a5.176 5.176 0 011.284-.538c1.643-.428 3.156-.19 4.335.687z",
  fill: "#fff"
}));

var SvgDontScowlImg = function SvgDontScowlImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDontScowlImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dont-scowl-img.81978e4b.svg";
export { ForwardRef as ReactComponent };